const RESTRICTION = {
  title: 'Visualisation des restrictions d\'affichage - S{week}',
  breadcrumb: {
    racine: 'Accueil',
    listeDemande: 'Liste des demandes affichages',
    restriction: 'Visualisation des restrictions d\'affichage',
  },
};

export default RESTRICTION;
